import { Globe } from 'lucide-react';
import { useI18n } from '@/lib/i18n';

export const Footer = () => {
  const { t, locale, toggleLocale } = useI18n();

  const links = [
    { label: t('footer.product'), href: '#features' },
    { label: t('footer.pricing'), href: '#pricing' },
    { label: t('footer.contact'), href: '#' },
    { label: t('footer.privacy'), href: '#' },
    { label: t('footer.terms'), href: '#' },
    { label: t('footer.security'), href: '#' },
  ];

  return (
    <footer
      className="bg-white border-t border-primary/5"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
          {/* Logo & Branding */}
          <div className="flex flex-col items-center lg:items-start gap-2">
            <a
              href="/"
              className="flex items-center"
              data-testid="footer-logo"
            >
              <span className="text-xl font-bold tracking-tight text-primary">
                AgriTrack
              </span>
            </a>
            <p className="text-xs text-muted-foreground font-mono tracking-wider">
              {t('footer.samperlabs')}
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap justify-center gap-6 lg:gap-8">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-mono uppercase tracking-wider"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Locale & Copyright */}
          <div className="flex flex-col items-center lg:items-end gap-4">
            <button
              onClick={toggleLocale}
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
              data-testid="footer-locale-switcher"
            >
              <Globe className="w-4 h-4" />
              <span className="font-mono uppercase tracking-wider">
                {locale === 'en' ? 'Türkçe' : 'English'}
              </span>
            </button>
            <p className="text-xs text-muted-foreground text-center lg:text-right">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
